import { Injectable } from '@angular/core';
import { Roles } from '../constants/roles.constant';
import { AuthenticationService } from './authentication.service';

import { SharedService } from './shared.service';


@Injectable({
    providedIn: 'root'
})

export class FilterDataService {
    constructor(

        private _authenticationService: AuthenticationService,
        private SharedService: SharedService

    ) { }


    firstDayDate() {
        let roleName = this._authenticationService.CurrentUserRoleName();
        var date = new Date();
        if (roleName == Roles.USER) {

            date = new Date(date.getFullYear(), date.getMonth(), 1);
            var now_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
                date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());

            return new Date(now_utc);
        }
        else {
            var now_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
                date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());

            return new Date(now_utc);
        }

    }

    lastDayDate() {
        let roleName = this._authenticationService.CurrentUserRoleName();
        var date = new Date();
        if (roleName == Roles.USER) {

            date = this.SharedService.getlocalDatetime(new Date(date.getFullYear(), date.getMonth() + 1, 0));
            var now_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
                date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
            return new Date(now_utc);
        }
        else {
            var date = new Date();
            var now_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
                date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
            return new Date(now_utc);
        }

    }

    toDayDate() {
        var date = new Date();
        var now_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
            date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
        return new Date(now_utc);
    }

    changeDate(date) {
        var now_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
            date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
        return new Date(now_utc);
    }

    monthStartDate() {
        var date = new Date();
        date = new Date(date.getFullYear(), date.getMonth(), 1);
        var now_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
            date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
        return new Date(now_utc);
    }
    monthLastDate() {
        var date = new Date();
        date = this.SharedService.getlocalDatetime(new Date(date.getFullYear(), date.getMonth() + 1, 0));
        var now_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
            date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
        return new Date(now_utc);
    }
    financialMonthStartDate() {
        var date = new Date();
        var april = new Date(date.getMonth() >= 3 ? date.getFullYear() : date.getFullYear() - 1, 3,1)
        
        var now_utc = Date.UTC(april.getUTCFullYear(), april.getUTCMonth(), april.getUTCDate(),
        april.getUTCHours(), april.getUTCMinutes(), april.getUTCSeconds());
        return new Date(now_utc);
    }
    financialMonthLastDate() {
        var date = new Date();
        var march = new Date(date.getFullYear() + 1, 2,31)
        var now_utc = Date.UTC(march.getUTCFullYear(), march.getUTCMonth(), march.getUTCDate(),
        march.getUTCHours(), march.getUTCMinutes(), march.getUTCSeconds());
        return new Date(now_utc);
    }
    nextMonthLastDate() {
        var date = new Date();
        date = this.SharedService.getlocalDatetime(new Date(date.getFullYear(), date.getMonth() + 2, 0));
        var now_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
            date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
        return new Date(now_utc);
    }
    currentFinancialYear(){
        var financial_year = "";
        var today = new Date();
        if ((today.getMonth() + 1) <= 3) {
            financial_year = (today.getFullYear() - 1) + "-" + today.getFullYear()
        } else {
            financial_year = today.getFullYear() + "-" + (today.getFullYear() + 1)
        }
        return financial_year;
    }
    fromMonth() {
        var date = new Date();
        return this.SharedService.getlocalDatetime(new Date(date.getFullYear(), date.getMonth()));
    }

    toMonth() {
        var date = new Date();
        return this.SharedService.getlocalDatetime(new Date(date.getFullYear(), date.getMonth()));
    }
    nextMonth() {
        var date = new Date();
        return this.SharedService.getlocalDatetime(new Date(date.getFullYear(), date.getMonth() + 1));
    }

    previousFromMonth() {
        var date = new Date();
        return this.SharedService.getlocalDatetime(new Date(date.getFullYear(), date.getMonth() - 1));
    }

    previoustoMonth() {
        var date = new Date();
        return this.SharedService.getlocalDatetime(new Date(date.getFullYear(), date.getMonth() - 1));
    }
    yearstartdate() {
        var date = new Date();
        date = new Date(date.getFullYear(), 0, 1);
        var now_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
            date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
        return new Date(now_utc);
    }
    yearEnddate() {
        var date = new Date();
        date = new Date(date.getFullYear(), 11, 31);
        var now_utc = Date.UTC(date.getUTCFullYear() + 1, date.getUTCMonth(), date.getUTCDate(),
            date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
        return new Date(now_utc);
    }

    convertTostring(date) {
        let month = ("0" + (date.getMonth() + 1)).slice(-2)
        let year = date.getFullYear().toString();
        let dates = year + month;

        return dates;
    }

    isAdmin() {
        let roleName = this._authenticationService.CurrentUserRoleName();
        if (roleName == Roles.ADMIN) {
            return 0;
        }
    }
    getPriorYear() {
        var date = new Date();
        return this.SharedService.getlocalDatetime(new Date(date.getFullYear() - 1, date.getMonth() + 1));

    }

}